module.exports = __webpack_public_path__ + "static/img/01.ed127df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/01.png
// module id = W2YP
// module chunks = 0